export const getVisibleNumbers = paymentCardNumbers => {
  if (!paymentCardNumbers) return '';
  const length = paymentCardNumbers.length;
  return paymentCardNumbers.substring(length - 4);
};
